import React from 'react';
import { useBranding } from '../../context/BrandingContext';

const Header = () => {
  const branding = useBranding();

  return (
    <header className="header header_bem">
      <div className="header__inner">
        <div className="header__brand">
          <a href={branding.site_url || "/"}>
            <div className="header__logo">
              {/* Настоящее лого */}
              <img
                src={branding.logo_url}
                alt={branding.site_name}
                style={{
                  width: '56px',
                  height: '56px',
                  objectFit: 'contain',
                  borderRadius: '0' // Явно убираем скругление
                }}
              />
              <span className="header__title">{branding.site_name}</span>
            </div>
          </a>
        </div>
        <div className="header_right">
          <div className="header__phone">{branding.phone}</div>
          <a href="/profile">
            {/* Иконка профиля (оставляем круглой) */}
            <div style={{
              width: '48px',
              height: '48px',
              background: '#07640a',
              borderRadius: '50%', // Здесь оставляем круг
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
            </div>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;